export const CURRENCY_SYMBOLS = {
  USD: "$", EUR: "€", GBP: "£", INR: "₹", CAD: "C$", AUD: "A$",
  JPY: "¥", CNY: "¥", MXN: "$", BRL: "R$", SGD: "S$", AED: "د.إ",
  NGN: "₦", ZAR: "R", KRW: "₩",
};

export function formatMoney(amount, code = "USD") {
  const sym = CURRENCY_SYMBOLS[code] || "";
  const num = Number(amount || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${sym}${num}`;
}

export const CATEGORIES = {
  expense: [
    { id: "food", label: "Food & Dining", color: "#FECACA" },
    { id: "rent", label: "Rent & Housing", color: "#C4B5FD" },
    { id: "books", label: "Books & Supplies", color: "#FDE68A" },
    { id: "transport", label: "Transport", color: "#93C5FD" },
    { id: "entertainment", label: "Entertainment", color: "#F9A8D4" },
    { id: "subscriptions", label: "Subscriptions", color: "#A7F3D0" },
    { id: "personal", label: "Personal Care", color: "#FDBA74" },
    { id: "health", label: "Health", color: "#86EFAC" },
    { id: "other_expense", label: "Other", color: "#D4D4D8" },
  ],
  income: [
    { id: "allowance", label: "Allowance", color: "#A7F3D0" },
    { id: "part_time", label: "Part-time Job", color: "#93C5FD" },
    { id: "scholarship", label: "Scholarship", color: "#FDE68A" },
    { id: "gift", label: "Gift", color: "#F9A8D4" },
    { id: "other_income", label: "Other", color: "#D4D4D8" },
  ],
};

export function getCategoryLabel(id) {
  const all = [...CATEGORIES.expense, ...CATEGORIES.income];
  return all.find((c) => c.id === id)?.label || id;
}

export function getCategoryColor(id) {
  const all = [...CATEGORIES.expense, ...CATEGORIES.income];
  return all.find((c) => c.id === id)?.color || "#D4D4D8";
}
